/*
 * @Author: your name
 * @Date: 2022-01-27 10:04:48
 * @LastEditTime: 2022-01-27 10:18:41
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dffl-drama-h5/Users/guwen/Desktop/gitCode/fore-movie-h5/src/components/OrderHead/index.tsx
 */
import React from 'react';
import NavBar from '@/components/NavBar';
import Notice from '@/components/Notice';
import DFImage from '@/components/dFImg';
import Icon from '@/components/Icon';
import styles from './index.less';
import {replaceNullToString} from '@/utils/commonHelper';
import { TLang } from '@/utils/lang';
import { getCookie } from '@/utils';
import supportRefundImg from '@/assets/imgs/order/order_right_refund.png';
import errorRefundImg from '@/assets/imgs/order/order_error_refund.png';
import refundRightArrow from '@/assets/imgs/order/order_right_arrow.png';
import DFDiscount from '../dfDiscount';
const OrderHead = (props) => {
  /**  116001768558886450000
   * top true 就补充一个88的高度
   * headExtRender 额外信息
   * is195 高度。来自于 订单详情
   */
  const {
    top,
    fixedBottom,
    headExtRender,
    is180,
    is195,
    navText,
    cinemaNotice,
    bgImg,
    movieImg,
    movieName,
    movieInfo,
    cinemaName,
    seatInfo,
    alert,
    movieNotice,
    showTag,
    ticketChangeDesc,
    refundTagExplain,
    supportChange,
    supportRefund,
    setRefundInstructionsModal,
    isVendor2
  } = replaceNullToString(props);


  return (
    <div className={`${styles.orderHeadWrapper} ${fixedBottom?styles.fixedBottom:''}`}>
      <NavBar showService={false} text={navText} initColor={top?'#333':'#333'} targetColor={top?'#333':'#FFF'}  targetBgColor={top?'#FFF':'#fff'} opacity={1} />
      {
        top?<div className={styles.topDiv}></div>:null
      }
      {
        headExtRender?headExtRender:null
      }
      <div className={styles.bgImgWrapper}>
        <div className={`${styles.orderInfoWrapper} ${is180? styles.is180:''} ${is195?styles.is195:''}`}>
          {
            cinemaNotice?
              <div className={styles.noti}>
                <Notice text={cinemaNotice}/>
              </div>:null
          }
          <div className={styles.info}>
            <div className={`${styles.logo} ${movieImg?'':'logo'}`}>
              {/* <img src={movieImg} alt=""/> */}
              <DFImage src={movieImg} />
            </div>
            <div className={styles.infoTextWrapper}>
              <p className={styles.movieName}>
                {isVendor2 == 1 ? <DFDiscount style={{marginRight: '5px', top: '-0.05rem'}}/> : null}
                {movieName}
              </p>
              <div className={styles.movieDesc}>
                <p>{movieInfo}</p>
                <p>{cinemaName}</p>
                {
                  seatInfo?<p>{seatInfo}</p>:null
                }
                {
                  alert?<p>
                    <span
                      style={
                        supportRefund
                        ? { color: window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF', borderColor: window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF'}
                        : { color: '#FF5757', borderColor: '#FF5757'}
                      }
                      className={
                        getCookie('df_lang')==='en-US'
                        ?styles.otherAlertEn
                        :styles.otherAlert
                      }
                    >{alert}
                    </span>
                    <span
                      style={
                        supportChange
                        ? { color: window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF', borderColor: window?.dffl_global?.allCommonTheme?.globalThemeColor || '#3FA6FF'}
                        : { color: '#FF5757', borderColor: '#FF5757'}
                      }
                      className={
                        getCookie('df_lang')==='en-US'
                        ?styles.otherAlertEn
                        :styles.otherAlert
                      }
                    >{ticketChangeDesc}
                    </span>
                  </p>:null
                }
              </div>
            </div>
          </div>
          {
            movieNotice?<div className={styles.movieNotice}><i /> <p>{movieNotice}</p></div>:null
          }
          {
            showTag && <div className={styles.tags}>
              <div className={styles.refund}>
                <div className={styles.support_refund}>
                  <img src={supportRefund ? supportRefundImg: errorRefundImg}/>
                  <span>{TLang( refundTagExplain, 'home', false, false, null)}</span>
                </div>
                <div className={styles.notSupport_refund}>
                  <img src={supportChange ? supportRefundImg : errorRefundImg}/>
                  <span>{TLang( ticketChangeDesc, 'home', false, false, null)}</span>
                </div>
              </div>
              <div className={styles.refund_instructions} onClick={() => {setRefundInstructionsModal(true);}}>
                <span>{TLang( '退票须知', 'home', false, false, null)}</span>
                <img src={refundRightArrow}/>
              </div>
            </div>
          }
        </div>
      </div>
      {
        props.children
      }
    </div>
  );
};
export default OrderHead;
